export const FlowForecastLabelConstants = {
  pointGPSMap: {
    'SIR AURTHUR COTTON BARRAGE': {
      name: 'SACB',
      gps: {
        7: [16.93070509876554, 81.84814453125001],
        8: [16.93070509876554, 81.84814453125001],
        9: [16.951724234434437, 81.78222656250001],
        10: [16.94515600686993, 81.77536010742189],
        11: [16.943185493859318, 81.76780700683595],
        12: [16.94614125563231, 81.76368713378908],
        13: [16.94614125563231, 81.76368713378908],
        14: [16.94712649923238, 81.7592239379883],
      },
    },
    JAIKWADI: {
      name: 'Jaikwadi',
      gps: {
        7: [19.30077482585895, 75.22338867187501],
        8: [19.378522756179393, 75.16845703125001],
        9: [19.440694401302856, 75.23712158203126],
        10: [19.45493871996861, 75.29754638671876],
        11: [19.460765580777778, 75.3270721435547],
        12: [19.469181787843333, 75.34217834472658],
        13: [19.47160945867597, 75.35350799560548],
        14: [19.473066043719353, 75.36191940307619],
      },
    },
    'Lower Manair Dam': {
      name: 'LMD',
      gps: {
        7: [18.57336188365185, 78.83789062500001],
        8: [18.349311744296475, 79.12353515625001],
        9: [18.375379094031825, 79.12628173828126],
        10: [18.376682358161855, 79.12628173828126],
        11: [18.3858049312974, 79.11323547363283],
        12: [18.39232075941476, 79.1173553466797],
        13: [18.39655591557585, 79.12370681762697],
        14: [18.398999227540877, 79.12791252136232],
      },
    },
    'Lakshmi Barrage': {
      name: 'Lakshmi Barrage',
      gps: {
        7: [18.625424540701264, 79.85961914062501],
        8: [18.651449894396634, 79.89807128906251],
        9: [18.646245142670608, 80.013427734375],
        10: [18.674869301779143, 80.01617431640626],
        11: [18.683975975631473, 80.04432678222658],
        12: [18.698285474146818, 80.05222320556642],
        13: [18.703651224325874, 80.05994796752931],
        14: [18.70470809445989, 80.06647109985352],
      },
    },
    'Nizam Sagar Project': {
      name: 'Nizam Sagar',
      gps: {
        7: [18.093644270502615, 77.86010742187501],
        8: [18.260653356758375, 77.98095703125001],
        9: [18.25021997706561, 77.94799804687501],
        10: [18.241090255870276, 77.94662475585939],
        11: [18.232612228279677, 77.92945861816408],
        12: [18.232612228279677, 77.9195022583008],
        13: [18.232612228279677, 77.91383743286134],
        14: [18.231878533383558, 77.91074752807619],
      },
    },
    'Sri Ram Sagar Project': {
      name: 'Sri Ram Sagar',
      gps: {
        7: [19.269665296502332, 77.78320312500001],
        8: [18.916679786648565, 78.31548871337844],
        9: [18.934866490675848, 78.28582763671876],
        10: [18.938763383969004, 78.28720092773439],
        11: [18.955648870479035, 78.32359313964845],
        12: [18.972857319272276, 78.34762573242189],
        13: [18.972857319272276, 78.34367752075197],
        14: [18.973425492476512, 78.34196090698244],
      },
    },
    'Ashti FFS': {
      name: 'Ashti',
      gps: {
        7: [19.694314241825747, 79.84863281250001],
        8: [19.694314241825747, 79.84863281250001],
        9: [19.678797982361385, 79.8211669921875],
        10: [19.686556300019273, 79.81018066406251],
        11: [19.683323713331085, 79.79988098144531],
        12: [19.684616755836014, 79.79473114013673],
        13: [19.683485344215097, 79.79061126708986],
        14: [19.682758003952603, 79.79001045227052],
      },
    },
    'Gudem (Pranhita River Bridge) FFS': {
      name: 'Gudem',
      gps: {
        7: [19.425153718960143, 80.07934570312501],
        8: [19.425153718960143, 80.07934570312501],
        9: [19.417382820241254, 80.00793457031251],
        10: [19.414792438099568, 80.00106811523439],
        11: [19.42321102911835, 79.991455078125],
        12: [19.420620739866045, 79.98390197753908],
        13: [19.419163684017594, 79.976863861084],
        14: [19.417868512297204, 79.97591972351076],
      },
    },
    'P.G. Bridge FFS': {
      name: 'P.G. Bridge',
      gps: {
        7: [19.921712747556207, 78.55224609375001],
        8: [19.921712747556207, 78.55224609375001],
        9: [19.85714397875396, 78.50830078125001],
        10: [19.85068565476247, 78.53027343750001],
        11: [19.835830512275315, 78.55499267578126],
        12: [19.828079451507115, 78.5570526123047],
        13: [19.82323484651046, 78.56838226318361],
        14: [19.820731742736147, 78.57396125793458],
      },
    },
    'Pauni FFS': {
      name: 'Pauni',
      gps: {
        7: [20.80747157680652, 79.36523437500001],
        8: [20.797201434307, 79.43664550781251],
        9: [20.804904106750566, 79.52178955078126],
        10: [20.788214486017242, 79.57534790039064],
        11: [20.798485240364766, 79.59388732910158],
        12: [20.79816428987463, 79.61414337158205],
        13: [20.797522386845728, 79.63233947753908],
        14: [20.79696071945482, 79.63869094848634],
      },
    },
    'Kumhari FFS': {
      name: 'Kumhari',
      gps: {
        7: [21.892084251561464, 80.23864746093751],
        8: [21.892084251561464, 80.23864746093751],
        9: [21.87424349655153, 80.20843505859376],
        10: [21.879341082799026, 80.20706176757814],
        11: [21.87615511273457, 80.19882202148439],
        12: [21.87551791018546, 80.19161224365236],
        13: [21.875995812364035, 80.18766403198244],
        14: [21.87488070479108, 80.18723487854004],
      },
    },
    'Kaddam Adi Narayana Reddy Project': {
      name: 'Kaddam Project',
      gps: {
        7: [19.150357455407484, 78.28857421875001],
        8: [19.233363381183896, 78.56240167135647],
        9: [19.11662435495838, 78.51379394531251],
        10: [19.108838815166017, 78.68820190429689],
        11: [19.10624355377579, 78.72528076171876],
        12: [19.10429708100911, 78.75205993652345],
        13: [19.1077033933188, 78.76356124877931],
        14: [19.108027800356272, 78.77394676208498],
      },
    },
    'Mogaligundla Baga Reddy Singur Project': {
      name: 'Singur Project',
      gps: {
        7: [17.712060974461494, 77.77221679687501],
        8: [17.769612247142653, 77.52502441406251],
        9: [17.712060974461494, 77.77221679687501],
        10: [17.740838922585365, 77.79830932617189],
        11: [17.723834329843772, 77.88757324218751],
        12: [17.73593391722475, 77.90027618408205],
        13: [17.73871343675409, 77.91452407836915],
        14: [17.740511926406995, 77.92121887207033],
      },
    },
    'Sri Pada Yellampalli Project': {
      name: 'SPYP',
      gps: {
        7: [18.79191774423444, 79.24438476562501],
        8: [18.79191774423444, 79.24438476562501],
        9: [18.932268511298073, 79.23339843750001],
        10: [18.894593271963213, 79.27185058593751],
        11: [18.866006397647876, 79.30343627929689],
        12: [18.840339028385475, 79.37347412109376],
        13: [18.84440058243192, 79.37107086181642],
        14: [18.843994431448696, 79.3696117401123],
      },
    },
    'Bamni  FFS': {
      name: 'Bamni',
      gps: {
        7: [19.836476416934698, 79.41467285156251],
        8: [19.836476416934698, 79.41467285156251],
        9: [19.846810534206607, 79.39270019531251],
        10: [19.832600949580605, 79.39682006835938],
        11: [19.820973980307976, 79.38926696777345],
        12: [19.816129158740658, 79.38480377197267],
        13: [19.81241469556276, 79.38325881958009],
        14: [19.81071893352826, 79.38171386718751],
      },
    },
    'Venkatraopet (Wardha River) FFS': {
      name: 'Venkatraopet',
      gps: {
        7: [19.476950206488414, 79.5245361328125],
        8: [19.476950206488414, 79.5245361328125],
        9: [19.476950206488414, 79.5245361328125],
        10: [19.493780502204146, 79.52316284179689],
        11: [19.50348949227559, 79.5568084716797],
        12: [19.510285438643873, 79.57191467285158],
        13: [19.51255069063782, 79.5816993713379],
        14: [19.514006907304044, 79.58564758300783],
      },
    },
    'Konta FFS': {
      name: 'Konta',
      gps: {
        7: [17.785304836705027, 81.44714355468751],
        8: [17.785304836705027, 81.44714355468751],
        9: [17.78268950081893, 81.40594482421876],
        10: [17.778766425198363, 81.40457153320314],
        11: [17.78007412664325, 81.39839172363283],
        12: [17.781054896445873, 81.39495849609376],
        13: [17.78121835755621, 81.39135360717775],
        14: [17.779910664486053, 81.38989448547365],
      },
    },
    'Ramakona FFS': {
      name: 'Ramakona',
      gps: {
        7: [21.733988636412214, 78.87634277343751],
        8: [21.733988636412214, 78.87634277343751],
        9: [21.733988636412214, 78.87634277343751],
        10: [21.72378293037045, 78.85025024414064],
        11: [21.7295237291648, 78.83583068847658],
        12: [21.72378293037045, 78.83274078369142],
        13: [21.721071917936143, 78.82776260375978],
        14: [21.719716392555323, 78.82750511169435],
      },
    },
    'Yelli FFS': {
      name: 'Yelli',
      gps: {
        7: [19.08288436934017, 77.51403808593751],
        8: [19.08288436934017, 77.51403808593751],
        9: [19.041348796589013, 77.48382568359376],
        10: [19.03875247795316, 77.48382568359376],
        11: [19.0342088226496, 77.4748992919922],
        12: [19.031936948379204, 77.47146606445314],
        13: [19.030476441367163, 77.46837615966797],
        14: [19.029421622761106, 77.46623039245607],
      },
    },
    'SRR Reservoir': {
      name: 'SRR Reservoir',
      gps: {
        7: [18.48481889407345, 78.87084960937501],
        8: [18.48481889407345, 78.87084960937501],
        9: [18.48481889407345, 78.87084960937501],
        10: [18.44834670293207, 78.90380859375001],
        11: [18.42489620284244, 78.94226074218751],
        12: [18.383524333263562, 78.9470672607422],
        13: [18.388899980368578, 78.95273208618165],
        14: [18.390528931240052, 78.95573616027833],
      },
    },
    'Parvathi Barrage': {
      name: 'Parvathi Barrage',
      gps: {
        7: [18.70869162255995, 79.44488525390626],
        8: [18.70869162255995, 79.44488525390626],
        9: [18.729501999072138, 79.44488525390626],
        10: [18.73600471634523, 79.52041625976564],
        11: [18.4268505333736, 78.9250946044922],
        12: [18.41023801612876, 78.94569396972658],
        13: [18.401931156150493, 78.94981384277345],
        14: [18.398021906913566, 78.95719528198244],
      },
    },
    'Upper Manair Dam': {
      name: 'Upper Manair Dam',
      gps: {
        7: [18.237177371422433, 78.56597900390626],
        8: [18.237177371422433, 78.56597900390626],
        9: [18.237177371422433, 78.56597900390626],
        10: [18.254132567888902, 78.54949951171875],
        11: [18.259349218570904, 78.54263305664064],
        12: [18.269456033308646, 78.54846954345703],
        13: [18.2743462162743, 78.55104446411134],
        14: [18.27565024178972, 78.55284690856935],
      },
    },
    'Bhadrachalam FFS': {
      name: 'Bhadrachalam',
      gps: {
        7: [17.696361965403323, 80.91430664062501],
        8: [17.696361965403323, 80.91430664062501],
        9: [17.696361965403323, 80.91430664062501],
        10: [17.696361965403323, 80.91430664062501],
        11: [17.687203576173054, 80.90675354003908],
        12: [17.6842597090483, 80.89473724365236],
        13: [17.679680264331335, 80.88838577270509],
        14: [17.680170924703482, 80.88881492614748],
      },
    },
    'Bhandara FFS': {
      name: 'Bhandara',
      gps: {
        7: [21.148553781704386, 79.71130371093751],
        8: [21.148553781704386, 79.71130371093751],
        9: [21.148553781704386, 79.71130371093751],
        10: [21.148553781704386, 79.71130371093751],
        11: [21.149194178968873, 79.69139099121095],
        12: [21.150474965190767, 79.68727111816408],
        13: [21.15031486751876, 79.68418121337892],
        14: [21.15031486751876, 79.68220710754396],
      },
    },
    'DEGLOOR FFS': {
      name: 'Degloor',
      gps: {
        7: [18.5186789808691, 77.574462890625],
        8: [18.5186789808691, 77.574462890625],
        9: [18.5186789808691, 77.574462890625],
        10: [18.533002385490306, 77.56347656250001],
        11: [18.541465651361552, 77.56690979003908],
        12: [18.550579468790442, 77.56896972656251],
        13: [18.554322502889885, 77.57291793823244],
        14: [18.558309557631762, 77.57454872131349],
      },
    },
    'Dhalegaon FFS': {
      name: 'Dhalegaon',
      gps: {
        7: [19.22039646558873, 76.38244628906251],
        8: [19.22039646558873, 76.38244628906251],
        9: [19.22039646558873, 76.38244628906251],
        10: [19.22039646558873, 76.38244628906251],
        11: [19.2236382904346, 76.36802673339845],
        12: [19.2236382904346, 76.36253356933594],
        13: [19.223800379998057, 76.35892868041994],
        14: [19.221936340364792, 76.35832786560059],
      },
    },
    'Gangakhed WL Station FFS': {
      name: 'Gangakhed WL Station',
      gps: {
        7: [18.950453518130693, 76.79443359375001],
        8: [18.950453518130693, 76.79443359375001],
        9: [18.950453518130693, 76.79443359375001],
        10: [18.950453518130693, 76.76971435546876],
        11: [18.95370063230706, 76.75598144531251],
        12: [18.959869975127553, 76.76559448242188],
        13: [18.965552062678555, 76.76679611206056],
        14: [18.96668845695318, 76.76928520202638],
      },
    },
    'Hivra FFS': {
      name: 'Hivra',
      gps: {
        7: [20.568510420140694, 78.35174560546876],
        8: [20.568510420140694, 78.35174560546876],
        9: [20.568510420140694, 78.35174560546876],
        10: [20.568510420140694, 78.35174560546876],
        11: [20.55565240377338, 78.34007263183595],
        12: [20.551794787820253, 78.33251953125001],
        13: [20.548580033472923, 78.32908630371095],
        14: [20.547374483160294, 78.32857131958009],
      },
    },
    'Indurthi Maneru FFS': {
      name: 'Indurthi Maneru',
      gps: {
        7: [18.40665471391907, 79.54101562500001],
        8: [18.40665471391907, 79.54101562500001],
        9: [18.3858049312974, 79.52728271484376],
        10: [18.40665471391907, 79.54101562500001],
        11: [18.408609251643206, 79.52316284179689],
        12: [18.411541016621005, 79.51560974121095],
        13: [18.41496134598085, 79.5180130004883],
        14: [18.41707865866127, 79.5212745666504],
      },
    },
    'Kanhargaon FFS': {
      name: 'Kanhargaon',
      gps: {
        7: [19.932041306115536, 77.15972900390626],
        8: [19.932041306115536, 77.15972900390626],
        9: [20.024967917222785, 77.06909179687501],
        10: [19.924294950473808, 77.12127685546876],
        11: [19.941723716612646, 77.14874267578125],
        12: [19.965281768666376, 77.16007232666017],
        13: [19.962538888728837, 77.15852737426758],
        14: [19.96245821506742, 77.15663909912111],
      },
    },
    'Keolari FFS': {
      name: 'Keolari',
      gps: {
        7: [22.355156218589755, 79.87335205078126],
        8: [22.355156218589755, 79.87335205078126],
        9: [22.355156218589755, 79.87335205078126],
        10: [22.413567638369805, 79.84588623046876],
        11: [22.398967083058714, 79.89669799804689],
        12: [22.39420570079307, 79.89841461181642],
        13: [22.38928543449661, 79.90064620971681],
        14: [22.386587150043592, 79.9024486541748],
      },
    },
    'Kopergaon FFS': {
      name: 'Kopergaon',
      gps: {
        7: [19.89588839936506, 74.52026367187501],
        8: [19.89588839936506, 74.52026367187501],
        9: [19.89588839936506, 74.52026367187501],
        10: [19.89588839936506, 74.52026367187501],
        11: [19.886848881896228, 74.51065063476564],
        12: [19.88588033156404, 74.50378417968751],
        13: [19.88555748013722, 74.50035095214845],
        14: [19.880553198881834, 74.49957847595216],
      },
    },
    'Mangrul FFS': {
      name: 'Mangrul',
      gps: {
        7: [20.20034600649375, 78.0194091796875],
        8: [20.20034600649375, 78.0194091796875],
        9: [20.20034600649375, 78.0194091796875],
        10: [20.20034600649375, 78.0194091796875],
        11: [20.19390176730693, 78.00567626953126],
        12: [20.1922906658513, 77.99846649169922],
        13: [20.186329445603576, 77.98936843872072],
        14: [20.186651679555613, 77.99031257629396],
      },
    },
    'NANDED FFS': {
      name: 'NANDED',
      gps: {
        7: [19.08288436934017, 77.24487304687501],
        8: [19.08288436934017, 77.24487304687501],
        9: [19.08288436934017, 77.24487304687501],
        10: [19.088075584093136, 77.24624633789064],
        11: [19.132194334419058, 77.29156494140626],
        12: [19.109487624150233, 77.31285095214845],
        13: [19.114678004380277, 77.32383728027345],
        14: [19.115732280454647, 77.32332229614259],
      },
    },
    'Nandgaon FFS': {
      name: 'Nandgaon',
      gps: {
        7: [20.542793305264492, 78.84887695312501],
        8: [20.542793305264492, 78.84887695312501],
        9: [20.542793305264492, 78.84887695312501],
        10: [20.542793305264492, 78.84887695312501],
        11: [20.549222989751847, 78.82827758789064],
        12: [20.549544466877066, 78.8207244873047],
        13: [20.55050889419565, 78.81883621215822],
        14: [20.547615593983462, 78.8133430480957],
      },
    },
    'Nasik FFS': {
      name: 'Nasik',
      gps: {
        7: [20.045610827439717, 73.75946044921876],
        8: [20.045610827439717, 73.75946044921876],
        9: [20.045610827439717, 73.75946044921876],
        10: [20.045610827439717, 73.75946044921876],
        11: [20.0236776452962, 73.7773132324218],
        12: [20.01593579138116, 73.77319335937501],
        13: [20.01545191285674, 73.76976013183595],
        14: [20.012387314301105, 73.76873016357423],
      },
    },
    'Pachegaon FFS': {
      name: 'Pachegaon',
      gps: {
        7: [19.505431220375755, 74.83612060546876],
        8: [19.505431220375755, 74.83612060546876],
        9: [19.505431220375755, 74.83612060546876],
        10: [19.51190347902067, 74.82788085937501],
        11: [19.519669847423703, 74.82856750488283],
        12: [19.525817957757994, 74.83989715576173],
        13: [19.530509779305916, 74.84436035156251],
        14: [19.53156137578552, 74.8436737060547],
      },
    },
    'Pathagudem FFS': {
      name: 'Pathagudem',
      gps: {
        7: [18.8543103618898, 80.36499023437501],
        8: [18.8543103618898, 80.36499023437501],
        9: [18.8543103618898, 80.36499023437501],
        10: [18.8543103618898, 80.36499023437501],
        11: [18.857559342519114, 80.35400390625001],
        12: [18.856259757817764, 80.35022735595705],
        13: [18.856909551426888, 80.34507751464845],
        14: [18.853985460366413, 80.34241676330568],
      },
    },
    'Perur FFS': {
      name: 'Perur',
      gps: {
        7: [18.58377568837094, 80.42816162109376],
        8: [18.58377568837094, 80.42816162109376],
        9: [18.58377568837094, 80.42816162109376],
        10: [18.579870586157117, 80.4144287109375],
        11: [18.578568865536027, 80.40893554687501],
        12: [18.579545156933808, 80.40515899658205],
        13: [18.57824343382752, 80.40189743041994],
        14: [18.57669762472794, 80.4012966156006],
      },
    },
    'Purna FFS': {
      name: 'Purna',
      gps: {
        7: [19.168518577121873, 77.03063964843751],
        8: [19.168518577121873, 77.03063964843751],
        9: [19.168518577121873, 77.03063964843751],
        10: [19.168518577121873, 77.03063964843751],
        11: [19.17759838774989, 77.02857971191408],
        12: [19.173058544975852, 77.02068328857422],
        13: [19.172409985796943, 77.01845169067384],
        14: [19.17119393045654, 77.01587677001955],
      },
    },
    'Rajegaon FFS': {
      name: 'Rajegaon',
      gps: {
        7: [21.625516012007278, 80.27435302734376],
        8: [21.625516012007278, 80.27435302734376],
        9: [21.64721706538783, 80.26885986328126],
        10: [21.625516012007278, 80.27435302734376],
        11: [21.618494385091246, 80.26611328125],
        12: [21.62136691005487, 80.25684356689455],
        13: [21.619292314417553, 80.25341033935548],
        14: [21.617616657745863, 80.25195121765138],
      },
    },
    'Rajoli FFS': {
      name: 'Rajoli',
      gps: {
        7: [20.18487938457412, 79.70031738281251],
        8: [20.18487938457412, 79.70031738281251],
        9: [20.17714549791179, 79.70855712890626],
        10: [20.191323996980405, 79.68933105468751],
        11: [20.187457261520663, 79.68246459960939],
        12: [20.18649056266289, 79.67594146728517],
        13: [20.182945948881375, 79.66976165771486],
        14: [20.183348749961866, 79.66856002807619],
      },
    },
    'Saigaon FFS': {
      name: 'Saigaon',
      gps: {
        7: [18.083200903334323, 77.02514648437501],
        8: [18.083200903334323, 77.02514648437501],
        9: [18.083200903334323, 77.02514648437501],
        10: [18.102781706635625, 76.96884155273439],
        11: [18.105392315190315, 77.01004028320314],
        12: [18.10963447114373, 77.01965332031251],
        14: [18.11387652438154, 77.0270347595215],
      },
    },
    'Salebardi FFS': {
      name: 'Salebardi',
      gps: {
        7: [20.912700155617568, 79.97222900390626],
        8: [20.912700155617568, 79.97222900390626],
        9: [20.912700155617568, 79.97222900390626],
        10: [20.91398297611762, 79.96124267578126],
        11: [20.913341567239513, 79.95300292968751],
        12: [20.915586486308083, 79.94716644287111],
        13: [20.91398297611762, 79.94115829467775],
        14: [20.913101038202818, 79.94004249572755],
      },
    },
    'Saloora FFS': {
      name: 'Saloora',
      gps: {
        7: [18.71389445678424, 77.81066894531251],
        8: [18.71389445678424, 77.81066894531251],
        9: [18.71389445678424, 77.81066894531251],
        10: [18.720397774505507, 77.80380249023439],
        11: [18.72169840803596, 77.79624938964845],
        12: [18.721048092521446, 77.79247283935548],
        13: [18.720072614559534, 77.78938293457033],
        14: [18.717471312480676, 77.78294563293458],
      },
    },
    'Satrapur (K.R.Bridge) FFS': {
      name: 'Satrapur (K.R.Bridge)',
      gps: {
        7: [21.17672864097083, 79.10705566406251],
        8: [21.17672864097083, 79.10705566406251],
        9: [21.17672864097083, 79.10705566406251],
        10: [21.195935695810785, 79.13040161132814],
        11: [21.23050210195646, 79.24507141113283],
        12: [21.204898133802203, 79.20902252197267],
        13: [21.20761876630091, 79.22103881835939],
        14: [21.210659413891168, 79.23399925231935],
      },
    },
    'Tekra FFS': {
      name: 'Tekra',
      gps: {
        7: [18.971233956586723, 79.99694824218751],
        8: [18.971233956586723, 79.99694824218751],
        9: [18.971233956586723, 79.99694824218751],
        10: [18.97383132929355, 79.97772216796876],
        11: [18.974480666145062, 79.96536254882814],
        12: [18.973181989911883, 79.96021270751955],
        13: [18.972532648000143, 79.95969772338867],
        14: [18.97220797609552, 79.95686531066896],
      },
    },
    'Wairagarh FFS': {
      name: 'Wairagarh',
      gps: {
        7: [20.388399919020127, 80.10955810546876],
        8: [20.388399919020127, 80.10955810546876],
        9: [20.388399919020127, 80.10955810546876],
        10: [20.389687171470065, 80.07659912109375],
        11: [20.397410460412775, 80.06561279296876],
        12: [20.402880889212472, 80.09342193603517],
        13: [20.406259586425527, 80.08707046508789],
        14: [20.407305358637178, 80.0852680206299],
      },
    },
    'Saraswati Barrage': {
      name: 'Saraswati Barrage',
      gps: {
        7: [18.758112082290626, 79.85412597656251],
        8: [18.758112082290626, 79.85412597656251],
        9: [18.758112082290626, 79.85412597656251],
        10: [18.762013081568668, 79.83627319335939],
        11: [18.761362921287123, 79.83558654785158],
        12: [18.764613697633195, 79.83180999755861],
        13: [18.765588918318805, 79.82614517211915],
        14: [18.765182577051824, 79.82425689697267],
      },
    },
    'N.M. WEIR': {
      name: 'N.M. Weir',
      gps: {
        7: [20.037870053952016, 74.15496826171876],
        8: [20.037870053952016, 74.15496826171876],
        9: [20.037870053952016, 74.15496826171876],
        10: [20.037870053952016, 74.15496826171876],
        11: [20.020451919152777, 74.15908813476564],
        12: [20.01593579138116, 74.15599822998048],
        13: [20.012226017986407, 74.15273666381837],
        14: [20.01093564151532, 74.15110588073732],
      },
    },
    Kunavaram_FFS: {
      name: 'Kunavaram',
      gps: {
        7: [17.562865076302113, 81.30157470703126],
        8: [17.562865076302113, 81.30157470703126],
        9: [17.562865076302113, 81.30157470703126],
        10: [17.568102108678996, 81.29058837890626],
        11: [17.567447487918926, 81.28509521484375],
        12: [17.564828981200645, 81.27857208251955],
        13: [17.564501665197238, 81.27737045288087],
        14: [17.56401069008235, 81.27453804016115],
      },
    },
    'Polavaram Project': {
      name: 'Polavaram',
      gps: {
        7: [17.253613343555305, 81.67510986328126],
        8: [17.253613343555305, 81.67510986328126],
        9: [17.253613343555305, 81.67510986328126],
        10: [17.253613343555305, 81.67510986328126],
        11: [17.252957595077618, 81.66275024414064],
        12: [17.25033457785963, 81.65348052978517],
        13: [17.252793657594, 81.65056228637697],
        14: [17.251646091129917, 81.65013313293457],
      },
    },
    'TALIPERU DAM': {
      name: 'Taliperu Dam',
      gps: {
        7: [18.122360322627372, 80.87722778320314],
        8: [18.122360322627372, 80.87722778320314],
        9: [18.122360322627372, 80.87722778320314],
        10: [18.122360322627372, 80.87722778320314],
        11: [17.129635558230763, 81.68540954589845],
        12: [17.127666988424984, 81.67957305908205],
        13: [17.12684674485404, 81.67699813842773],
        14: [17.126272572201337, 81.6745948791504],
      },
    },
    'Bhatpalli FFS': {
      name: 'Bhatpalli',
      gps: {
        7: [19.313735384650652, 79.47235107421876],
        8: [19.313735384650652, 79.47235107421876],
        9: [19.313735384650652, 79.47235107421876],
        10: [19.32928669899883, 79.47647094726564],
        11: [19.337709709532252, 79.48608398437501],
        12: [19.345160472028386, 79.49157714843751],
        13: [19.35001948171314, 79.49689865112306],
        14: [19.35147715640247, 79.50204849243165],
      },
    },
    'Chikhali FFS': {
      name: 'Chikhali',
      gps: {
        7: [21.591042935724243, 79.82666015625001],
        8: [21.591042935724243, 79.82666015625001],
        9: [21.591042935724243, 79.82666015625001],
        10: [21.587212086914178, 79.81292724609376],
        11: [21.58274263521184, 79.81018066406251],
        12: [21.581784877616634, 79.8036575317383],
        13: [21.580348229349678, 79.801082611084],
        14: [21.578193230233875, 79.80031013488771],
      },
    },
    'Chinnur FFS': {
      name: 'Chinnur',
      gps: {
        7: [18.89329397442673, 79.76074218750001],
        8: [18.89329397442673, 79.76074218750001],
        9: [18.89329397442673, 79.76074218750001],
        10: [18.89329397442673, 79.76074218750001],
        11: [18.87900103610622, 79.76966857910158],
        12: [18.87022976564919, 79.79438781738283],
        13: [18.87022976564919, 79.80983734130861],
        14: [18.871529242090286, 79.81404304504396],
      },
    },
    'G.R.BRIDGE FFS': {
      name: 'G.R.BRIDGE',
      gps: {
        7: [19.043945074620254, 76.67907714843751],
        8: [19.043945074620254, 76.67907714843751],
        9: [19.043945074620254, 76.67907714843751],
        10: [19.043945074620254, 76.67907714843751],
        11: [19.02966504303392, 76.70448303222656],
        12: [19.021875417406388, 76.71752929687501],
        13: [19.01814275905784, 76.7274856567383],
        14: [19.01814275905784, 76.7274856567383],
      },
    },
    'Jannepally FFS': {
      name: 'Jannepally',
      gps: {
        7: [18.78931754947933, 78.09631347656251],
        8: [18.78931754947933, 78.09631347656251],
        9: [18.78931754947933, 78.09631347656251],
        10: [18.81921736408459, 78.08670043945314],
        11: [18.815317689624997, 78.07640075683595],
        12: [18.81661759116094, 78.07125091552736],
        13: [18.815317689624997, 78.06833267211915],
        14: [18.81499271267089, 78.06627273559572],
      },
    },
    'Kalamadugu Bridge FFS': {
      name: 'Kalamadugu Bridge',
      gps: {
        7: [19.041348796589013, 78.91754150390626],
        8: [19.041348796589013, 78.91754150390626],
        9: [19.041348796589013, 78.91754150390626],
        10: [19.06471383653979, 78.9312744140625],
        11: [19.07120354126221, 78.94020080566408],
        12: [19.08028870094176, 78.94500732421876],
        13: [19.085155545818854, 78.94981384277345],
        14: [19.087102243723283, 78.9514446258545],
      },
    },
    'Kaleshwaram FFS': {
      name: 'Kaleshwaram',
      gps: {
        7: [18.823116948090494, 79.97222900390626],
        8: [18.823116948090494, 79.97222900390626],
        9: [18.823116948090494, 79.97222900390626],
        10: [18.81661759116094, 79.94201660156251],
        11: [18.80751806940864, 79.93309020996095],
        12: [18.80654309145234, 79.92931365966798],
        13: [18.806705588170765, 79.92622375488283],
        14: [18.806380594576975, 79.92356300354005],
      },
    },
    'Katterasala FFS': {
      name: 'Katterasala',
      gps: {
        7: [18.7971180132841, 79.63714599609376],
        8: [18.7971180132841, 79.63714599609376],
        9: [18.7971180132841, 79.63714599609376],
        10: [18.801018109649718, 79.67422485351562],
        11: [18.808168051573745, 79.73121643066408],
        12: [18.810117983000747, 79.76692199707033],
        13: [18.812392874429676, 79.77258682250978],
        14: [18.814261512227915, 79.77962493896484],
      },
    },
    'Kyathanpally Peddavagu FFS': {
      name: 'Kyathanpally Peddavagu',
      gps: {
        7: [19.121814511124505, 79.62341308593751],
        8: [19.121814511124505, 79.62341308593751],
        9: [19.121814511124505, 79.62341308593751],
        10: [19.03485792387594, 79.76760864257814],
        11: [19.04005064234637, 79.80743408203126],
        12: [19.046541312042145, 79.83592987060548],
        13: [19.050111072181206, 79.84416961669922],
        14: [19.05181479426554, 79.84828948974611],
      },
    },
    'Mancherial FFS': {
      name: 'Mancherial',
      gps: {
        7: [18.86210780968572, 79.48059082031251],
        8: [18.86210780968572, 79.48059082031251],
        9: [18.86210780968572, 79.48059082031251],
        10: [18.86210780968572, 79.46273803710939],
        11: [18.85041150208793, 79.46411132812501],
        12: [18.85106131834572, 79.45484161376955],
        13: [18.850898864517166, 79.4524383544922],
        14: [18.84862449440537, 79.45046424865724],
      },
    },
    'Nandigaon Peddavagu FFS': {
      name: 'Nandigaon Peddavagu',
      gps: {
        7: [19.202241064923054, 79.82940673828126],
        8: [19.202241064923054, 79.82940673828126],
        9: [19.202241064923054, 79.82940673828126],
        10: [19.215209412824127, 79.81704711914064],
        11: [19.22104483567416, 79.85687255859376],
        12: [19.225259178873625, 79.88124847412111],
        13: [19.2278525671147, 79.88725662231447],
        14: [19.23255297894658, 79.89970207214357],
      },
    },
    'Pothangal FFS': {
      name: 'Pothangal',
      gps: {
        7: [18.60460138845525, 77.76672363281251],
        8: [18.60460138845525, 77.76672363281251],
        9: [18.60460138845525, 77.76672363281251],
        10: [18.608505923648544, 77.74612426757814],
        11: [18.609156670804538, 77.74131774902345],
        12: [18.60785517400399, 77.73719787597658],
        13: [18.607367110137492, 77.73496627807619],
        14: [18.606635011713234, 77.73282051086427],
      },
    },
    'Sirpur FFS': {
      name: 'Sirpur',
      gps: {
        7: [19.55202569751752, 79.65087890625],
        8: [19.55202569751752, 79.65087890625],
        9: [19.55202569751752, 79.65087890625],
        10: [19.553319796635336, 79.64126586914064],
        11: [19.55784906179329, 79.63027954101562],
        12: [19.559466625669167, 79.62478637695314],
        13: [19.56140768090356, 79.62066650390626],
        14: [19.561326804068617, 79.62006568908693],
      },
    },
    'Somanpally FFS': {
      name: 'Somanpally',
      gps: {
        7: [18.630629930377246, 79.56024169921876],
        8: [18.630629930377246, 79.56024169921876],
        9: [18.630629930377246, 79.56024169921876],
        10: [18.624123168375732, 79.81292724609376],
        11: [18.628677927929953, 79.80812072753908],
        12: [18.626725903064777, 79.80159759521484],
        13: [18.627213911382636, 79.79782104492189],
        14: [18.628027255465685, 79.7941303253174],
      },
    },
    'Zari FFS': {
      name: 'Zari',
      gps: {
        7: [19.409611549990895, 76.79992675781251],
        8: [19.409611549990895, 76.79992675781251],
        9: [19.409611549990895, 76.79992675781251],
        10: [19.409611549990895, 76.79992675781251],
        11: [19.403782853560912, 76.78619384765626],
        12: [19.39860161472401, 76.78035736083986],
        13: [19.39876353093527, 76.77623748779298],
        14: [9.393663092886097, 76.77512168884279],
      },
    },
    'Chainage 5.2 km of Patiseema RMC': {
      name: 'Patiseema RMC',
      gps: {
        7: [17.151288449816747, 81.55975341796876],
        8: [17.151288449816747, 81.55975341796876],
        9: [17.151288449816747, 81.55975341796876],
        10: [17.15260066514817, 81.56250000000001],
        11: [17.15456897075329, 81.55563354492189],
        12: [17.162441984429595, 81.55803680419923],
        13: [17.166870407813587, 81.5592384338379],
        14: [17.16859254390992, 81.558895111084],
      },
    },
    'Koida FFS': {
      name: 'Koida',
      gps: {
        7: [17.522272941245216, 81.41418457031251],
        8: [17.522272941245216, 81.41418457031251],
        9: [17.522272941245216, 81.41418457031251],
        10: [17.522272941245216, 81.41418457031251],
        11: [17.511796076569713, 81.40937805175783],
        12: [17.50590257451841, 81.40594482421876],
        13: [17.495097324176477, 81.39787673950197],
        14: [17.496734524616866, 81.39787673950197],
      },
    },
    Tallapudi_RR_FFS: {
      name: 'Tallapudi',
      gps: {
        7: [17.126354596974554, 81.69433593750001],
        8: [17.126354596974554, 81.69433593750001],
        9: [17.126354596974554, 81.69433593750001],
        10: [17.126354596974554, 81.69433593750001],
        11: [17.131604107190874, 81.68678283691408],
        12: [17.127338891430828, 81.68025970458986],
        13: [17.126354596974554, 81.6768264770508],
        14: [17.12602649766456, 81.67519569396974],
      },
    },
  },
  ZoomToLabelMap: {
    7: [
      'SIR AURTHUR COTTON BARRAGE',
      'JAIKWADI',
      'Lakshmi Barrage',
      'Nizam Sagar Project',
      'Sri Ram Sagar Project',
      'Gudem (Pranhita River Bridge) FFS',
      'P.G. Bridge FFS',
      'Pauni FFS',
    ],

    8: [
      'SIR AURTHUR COTTON BARRAGE',
      'JAIKWADI',
      'Lower Manair Dam',
      'Lakshmi Barrage',
      'Nizam Sagar Project',
      'Sri Ram Sagar Project',
      'Ashti FFS',
      'Gudem (Pranhita River Bridge) FFS',
      'P.G. Bridge FFS',
      'Pauni FFS',
      'Kumhari FFS',
      'Kaddam Adi Narayana Reddy Project',
      'Mogaligundla Baga Reddy Singur Project',
      'Sri Pada Yellampalli Project',
      'Venkatraopet (Wardha River) FFS',
      'Konta FFS',
      'Ramakona FFS',
      'Yelli FFS',
    ],

    9: [
      'SIR AURTHUR COTTON BARRAGE',
      'JAIKWADI',
      'Lower Manair Dam',
      'Lakshmi Barrage',
      'Nizam Sagar Project',
      'Sri Ram Sagar Project',
      'Ashti FFS',
      'Gudem (Pranhita River Bridge) FFS',
      'P.G. Bridge FFS',
      'Pauni FFS',
      'Kumhari FFS',
      'Kaddam Adi Narayana Reddy Project',
      'Mogaligundla Baga Reddy Singur Project',
      'Sri Pada Yellampalli Project',
      'Bamni  FFS',
      'Venkatraopet (Wardha River) FFS',
      'Konta FFS',
      'Ramakona FFS',
      'Yelli FFS',
      'SRR Reservoir',
      'Parvathi Barrage',
      'Upper Manair Dam',
      'Bhadrachalam FFS',
      'Bhandara FFS',
      'DEGLOOR FFS',
      'Dhalegaon FFS',
      'Gangakhed WL Station FFS',
      'Hivra FFS',
      'Indurthi Maneru FFS',
      'Kanhargaon FFS',
      'Keolari FFS',
      'Kopergaon FFS',
      'Mangrul FFS',
      'NANDED FFS',
      'Nandgaon FFS',
      'Nasik FFS',
      'Pachegaon FFS',
      'Pathagudem FFS',
      'Perur FFS',
      'Purna FFS',
      'Rajegaon FFS',
      'Rajoli FFS',
      'Saigaon FFS',
      'Salebardi FFS',
      'Saloora FFS',
      'Satrapur (K.R.Bridge) FFS',
      'Tekra FFS',
      'Wairagarh FFS',
    ],

    10: [
      'SIR AURTHUR COTTON BARRAGE',
      'JAIKWADI',
      'Lower Manair Dam',
      'Lakshmi Barrage',
      'Nizam Sagar Project',
      'Sri Ram Sagar Project',
      'Ashti FFS',
      'Gudem (Pranhita River Bridge) FFS',
      'P.G. Bridge FFS',
      'Pauni FFS',
      'Kumhari FFS',
      'Kaddam Adi Narayana Reddy Project',
      'Mogaligundla Baga Reddy Singur Project',
      'Sri Pada Yellampalli Project',
      'Bamni  FFS',
      'Venkatraopet (Wardha River) FFS',
      'Konta FFS',
      'Ramakona FFS',
      'Yelli FFS',
      'SRR Reservoir',
      'Parvathi Barrage',
      'Upper Manair Dam',
      'Bhadrachalam FFS',
      'Bhandara FFS',
      'DEGLOOR FFS',
      'Dhalegaon FFS',
      'Gangakhed WL Station FFS',
      'Hivra FFS',
      'Indurthi Maneru FFS',
      'Kanhargaon FFS',
      'Keolari FFS',
      'Kopergaon FFS',
      'Mangrul FFS',
      'NANDED FFS',
      'Nandgaon FFS',
      'Nasik FFS',
      'Pachegaon FFS',
      'Pathagudem FFS',
      'Perur FFS',
      'Purna FFS',
      'Rajegaon FFS',
      'Rajoli FFS',
      'Saigaon FFS',
      'Salebardi FFS',
      'Saloora FFS',
      'Satrapur (K.R.Bridge) FFS',
      'Tekra FFS',
      'Wairagarh FFS',
      'Saraswati Barrage',
      'N.M. WEIR',
      'Kunavaram_FFS',
      'Polavaram Project',
      'TALIPERU DAM',
      'Bhatpalli FFS',
      'Chikhali FFS',
      'Chinnur FFS',
      'G.R.BRIDGE FFS',
      'Jannepally FFS',
      'Kalamadugu Bridge FFS',
      'Kaleshwaram FFS',
      'Katterasala FFS',
      '',
      'Kyathanpally Peddavagu FFS',
      'Mancherial FFS',
      'Nandigaon Peddavagu FFS',
      'Pothangal FFS',
      'Sirpur FFS',
      'Somanpally FFS',
      'Zari FFS',
      'Chainage 5.2 km of Patiseema RMC',
      'Koida FFS',
      'Tallapudi_RR_FFS',
    ],

    11: [
      'SIR AURTHUR COTTON BARRAGE',
      'JAIKWADI',
      'Lower Manair Dam',
      'Lakshmi Barrage',
      'Nizam Sagar Project',
      'Sri Ram Sagar Project',
      'Ashti FFS',
      'Gudem (Pranhita River Bridge) FFS',
      'P.G. Bridge FFS',
      'Pauni FFS',
      'Kumhari FFS',
      'Kaddam Adi Narayana Reddy Project',
      'Mogaligundla Baga Reddy Singur Project',
      'Sri Pada Yellampalli Project',
      'Bamni  FFS',
      'Venkatraopet (Wardha River) FFS',
      'Konta FFS',
      'Ramakona FFS',
      'Yelli FFS',
      'SRR Reservoir',
      'Parvathi Barrage',
      'Upper Manair Dam',
      'Bhadrachalam FFS',
      'Bhandara FFS',
      'DEGLOOR FFS',
      'Dhalegaon FFS',
      'Gangakhed WL Station FFS',
      'Hivra FFS',
      'Indurthi Maneru FFS',
      'Kanhargaon FFS',
      'Keolari FFS',
      'Kopergaon FFS',
      'Mangrul FFS',
      'NANDED FFS',
      'Nandgaon FFS',
      'Nasik FFS',
      'Pachegaon FFS',
      'Pathagudem FFS',
      'Perur FFS',
      'Purna FFS',
      'Rajegaon FFS',
      'Rajoli FFS',
      'Saigaon FFS',
      'Salebardi FFS',
      'Saloora FFS',
      'Satrapur (K.R.Bridge) FFS',
      'Tekra FFS',
      'Wairagarh FFS',
      'Saraswati Barrage',
      'N.M. WEIR',
      'Kunavaram_FFS',
      'Polavaram Project',
      'TALIPERU DAM',
      'Bhatpalli FFS',
      'Chikhali FFS',
      'Chinnur FFS',
      'G.R.BRIDGE FFS',
      'Jannepally FFS',
      'Kalamadugu Bridge FFS',
      'Kaleshwaram FFS',
      'Katterasala FFS',
      '',
      'Kyathanpally Peddavagu FFS',
      'Mancherial FFS',
      'Nandigaon Peddavagu FFS',
      'Pothangal FFS',
      'Sirpur FFS',
      'Somanpally FFS',
      'Zari FFS',
      'Chainage 5.2 km of Patiseema RMC',
      'Koida FFS',
      'Tallapudi_RR_FFS',
    ],
    12: [
      'SIR AURTHUR COTTON BARRAGE',
      'JAIKWADI',
      'Lower Manair Dam',
      'Lakshmi Barrage',
      'Nizam Sagar Project',
      'Sri Ram Sagar Project',
      'Ashti FFS',
      'Gudem (Pranhita River Bridge) FFS',
      'P.G. Bridge FFS',
      'Pauni FFS',
      'Kumhari FFS',
      'Kaddam Adi Narayana Reddy Project',
      'Mogaligundla Baga Reddy Singur Project',
      'Sri Pada Yellampalli Project',
      'Bamni  FFS',
      'Venkatraopet (Wardha River) FFS',
      'Konta FFS',
      'Ramakona FFS',
      'Yelli FFS',
      'SRR Reservoir',
      'Parvathi Barrage',
      'Upper Manair Dam',
      'Bhadrachalam FFS',
      'Bhandara FFS',
      'DEGLOOR FFS',
      'Dhalegaon FFS',
      'Gangakhed WL Station FFS',
      'Hivra FFS',
      'Indurthi Maneru FFS',
      'Kanhargaon FFS',
      'Keolari FFS',
      'Kopergaon FFS',
      'Mangrul FFS',
      'NANDED FFS',
      'Nandgaon FFS',
      'Nasik FFS',
      'Pachegaon FFS',
      'Pathagudem FFS',
      'Perur FFS',
      'Purna FFS',
      'Rajegaon FFS',
      'Rajoli FFS',
      'Saigaon FFS',
      'Salebardi FFS',
      'Saloora FFS',
      'Satrapur (K.R.Bridge) FFS',
      'Tekra FFS',
      'Wairagarh FFS',
      'Saraswati Barrage',
      'N.M. WEIR',
      'Kunavaram_FFS',
      'Polavaram Project',
      'TALIPERU DAM',
      'Bhatpalli FFS',
      'Chikhali FFS',
      'Chinnur FFS',
      'G.R.BRIDGE FFS',
      'Jannepally FFS',
      'Kalamadugu Bridge FFS',
      'Kaleshwaram FFS',
      'Katterasala FFS',
      '',
      'Kyathanpally Peddavagu FFS',
      'Mancherial FFS',
      'Nandigaon Peddavagu FFS',
      'Pothangal FFS',
      'Sirpur FFS',
      'Somanpally FFS',
      'Zari FFS',
      'Chainage 5.2 km of Patiseema RMC',
      'Koida FFS',
      'Tallapudi_RR_FFS',
    ],
    13: [
      'SIR AURTHUR COTTON BARRAGE',
      'JAIKWADI',
      'Lower Manair Dam',
      'Lakshmi Barrage',
      'Nizam Sagar Project',
      'Sri Ram Sagar Project',
      'Ashti FFS',
      'Gudem (Pranhita River Bridge) FFS',
      'P.G. Bridge FFS',
      'Pauni FFS',
      'Kumhari FFS',
      'Kaddam Adi Narayana Reddy Project',
      'Mogaligundla Baga Reddy Singur Project',
      'Sri Pada Yellampalli Project',
      'Bamni  FFS',
      'Venkatraopet (Wardha River) FFS',
      'Konta FFS',
      'Ramakona FFS',
      'Yelli FFS',
      'SRR Reservoir',
      'Parvathi Barrage',
      'Upper Manair Dam',
      'Bhadrachalam FFS',
      'Bhandara FFS',
      'DEGLOOR FFS',
      'Dhalegaon FFS',
      'Gangakhed WL Station FFS',
      'Hivra FFS',
      'Indurthi Maneru FFS',
      'Kanhargaon FFS',
      'Keolari FFS',
      'Kopergaon FFS',
      'Mangrul FFS',
      'NANDED FFS',
      'Nandgaon FFS',
      'Nasik FFS',
      'Pachegaon FFS',
      'Pathagudem FFS',
      'Perur FFS',
      'Purna FFS',
      'Rajegaon FFS',
      'Rajoli FFS',
      'Saigaon FFS',
      'Salebardi FFS',
      'Saloora FFS',
      'Satrapur (K.R.Bridge) FFS',
      'Tekra FFS',
      'Wairagarh FFS',
      'Saraswati Barrage',
      'N.M. WEIR',
      'Kunavaram_FFS',
      'Polavaram Project',
      'TALIPERU DAM',
      'Bhatpalli FFS',
      'Chikhali FFS',
      'Chinnur FFS',
      'G.R.BRIDGE FFS',
      'Jannepally FFS',
      'Kalamadugu Bridge FFS',
      'Kaleshwaram FFS',
      'Katterasala FFS',
      '',
      'Kyathanpally Peddavagu FFS',
      'Mancherial FFS',
      'Nandigaon Peddavagu FFS',
      'Pothangal FFS',
      'Sirpur FFS',
      'Somanpally FFS',
      'Zari FFS',
      'Chainage 5.2 km of Patiseema RMC',
      'Koida FFS',
      'Tallapudi_RR_FFS',
    ],
    14: [
      'SIR AURTHUR COTTON BARRAGE',
      'JAIKWADI',
      'Lower Manair Dam',
      'Lakshmi Barrage',
      'Nizam Sagar Project',
      'Sri Ram Sagar Project',
      'Ashti FFS',
      'Gudem (Pranhita River Bridge) FFS',
      'P.G. Bridge FFS',
      'Pauni FFS',
      'Kumhari FFS',
      'Kaddam Adi Narayana Reddy Project',
      'Mogaligundla Baga Reddy Singur Project',
      'Sri Pada Yellampalli Project',
      'Bamni  FFS',
      'Venkatraopet (Wardha River) FFS',
      'Konta FFS',
      'Ramakona FFS',
      'Yelli FFS',
      'SRR Reservoir',
      'Parvathi Barrage',
      'Upper Manair Dam',
      'Bhadrachalam FFS',
      'Bhandara FFS',
      'DEGLOOR FFS',
      'Dhalegaon FFS',
      'Gangakhed WL Station FFS',
      'Hivra FFS',
      'Indurthi Maneru FFS',
      'Kanhargaon FFS',
      'Keolari FFS',
      'Kopergaon FFS',
      'Mangrul FFS',
      'NANDED FFS',
      'Nandgaon FFS',
      'Nasik FFS',
      'Pachegaon FFS',
      'Pathagudem FFS',
      'Perur FFS',
      'Purna FFS',
      'Rajegaon FFS',
      'Rajoli FFS',
      'Saigaon FFS',
      'Salebardi FFS',
      'Saloora FFS',
      'Satrapur (K.R.Bridge) FFS',
      'Tekra FFS',
      'Wairagarh FFS',
      'Saraswati Barrage',
      'N.M. WEIR',
      'Kunavaram_FFS',
      'Polavaram Project',
      'TALIPERU DAM',
      'Bhatpalli FFS',
      'Chikhali FFS',
      'Chinnur FFS',
      'G.R.BRIDGE FFS',
      'Jannepally FFS',
      'Kalamadugu Bridge FFS',
      'Kaleshwaram FFS',
      'Katterasala FFS',
      '',
      'Kyathanpally Peddavagu FFS',
      'Mancherial FFS',
      'Nandigaon Peddavagu FFS',
      'Pothangal FFS',
      'Sirpur FFS',
      'Somanpally FFS',
      'Zari FFS',
      'Chainage 5.2 km of Patiseema RMC',
      'Koida FFS',
      'Tallapudi_RR_FFS',
    ],
  },
  SubBasinPlot: {
    //  "Middle Godavari" :{"name":"Middle Godavari" ,"gps":[18.651449894396634, 78.14025878906251]},
    Indravathi: {
      name: 'Indravathi',
      gps: [19.476950206488414, 81.15600585937501],
    },
    Wardha: { name: 'Wardha', gps: [21.105000275382064, 78.13476562500001] },
    Sabri: { name: 'Sabri', gps: [18.375379094031825, 82.11181640625] },
    Purna: { name: 'Purna', gps: [19.90105360620521, 76.00341796875] },
    Manjra: { name: 'Manjra', gps: [18.47960905583198, 76.17919921875001] },
    Penganga: {
      name: 'Penganga',
      gps: [20.024967917222785, 77.35473632812501],
    },
    // "Upper Godavari" : {"name":"Upper Godavari", "gps":[19.9526963975442, 74.75097656250001]},
    Pravara: { name: 'Pravara', gps: [19.394067895396613, 74.12465826146813] },
    // "Pranhita" :{"name":"Pranhita and Others" ,"gps":[18.92707243132613, 80.54488201142351]},
    // "Lower Godavari" :{"name":"Lower Godavari", "gps":[18.427501971948608, 80.78247070312501]},
    Weinganga: {
      name: 'Weinganga',
      gps: [21.268899719967695, 79.85961914062501],
    },
  },

  zoomToLabelMap :{
    "7":["SIR AURTHUR COTTON BARRAGE","JAIKWADI","Lakshmi Barrage","Nizam Sagar Project","Sri Ram Sagar Project","Gudem (Pranhita River Bridge) FFS","P.G. Bridge FFS","Pauni FFS"],

    "8":["SIR AURTHUR COTTON BARRAGE","JAIKWADI","Lower Manair Dam","Lakshmi Barrage","Nizam Sagar Project","Sri Ram Sagar Project","Ashti FFS","Gudem (Pranhita River Bridge) FFS","P.G. Bridge FFS","Pauni FFS",
        "Kumhari FFS","Kaddam Adi Narayana Reddy Project","Mogaligundla Baga Reddy Singur Project","Sri Pada Yellampalli Project","Venkatraopet (Wardha River) FFS","Konta FFS","Ramakona FFS","Yelli FFS"],

    "9":["SIR AURTHUR COTTON BARRAGE","JAIKWADI","Lower Manair Dam","Lakshmi Barrage","Nizam Sagar Project","Sri Ram Sagar Project","Ashti FFS","Gudem (Pranhita River Bridge) FFS","P.G. Bridge FFS","Pauni FFS",
        "Kumhari FFS","Kaddam Adi Narayana Reddy Project","Mogaligundla Baga Reddy Singur Project","Sri Pada Yellampalli Project","Bamni  FFS","Venkatraopet (Wardha River) FFS","Konta FFS","Ramakona FFS","Yelli FFS",
        "SRR Reservoir", "Parvathi Barrage", "Upper Manair Dam", "Bhadrachalam FFS", "Bhandara FFS", "DEGLOOR FFS", "Dhalegaon FFS", "Gangakhed WL Station FFS", "Hivra FFS", "Indurthi Maneru FFS", "Kanhargaon FFS", "Keolari FFS", "Kopergaon FFS", "Mangrul FFS", "NANDED FFS", "Nandgaon FFS", "Nasik FFS", "Pachegaon FFS", "Pathagudem FFS", "Perur FFS",
        "Purna FFS", "Rajegaon FFS", "Rajoli FFS", "Saigaon FFS", "Salebardi FFS", "Saloora FFS", "Satrapur (K.R.Bridge) FFS", "Tekra FFS", "Wairagarh FFS"],

    "10": ["SIR AURTHUR COTTON BARRAGE","JAIKWADI","Lower Manair Dam","Lakshmi Barrage","Nizam Sagar Project","Sri Ram Sagar Project","Ashti FFS","Gudem (Pranhita River Bridge) FFS","P.G. Bridge FFS","Pauni FFS",
          "Kumhari FFS","Kaddam Adi Narayana Reddy Project","Mogaligundla Baga Reddy Singur Project","Sri Pada Yellampalli Project","Bamni  FFS","Venkatraopet (Wardha River) FFS","Konta FFS","Ramakona FFS","Yelli FFS",
          "SRR Reservoir", "Parvathi Barrage", "Upper Manair Dam", "Bhadrachalam FFS", "Bhandara FFS", "DEGLOOR FFS", "Dhalegaon FFS", "Gangakhed WL Station FFS", "Hivra FFS", "Indurthi Maneru FFS", "Kanhargaon FFS", "Keolari FFS", "Kopergaon FFS", "Mangrul FFS", "NANDED FFS", "Nandgaon FFS", "Nasik FFS", "Pachegaon FFS", "Pathagudem FFS", "Perur FFS",
          "Purna FFS", "Rajegaon FFS", "Rajoli FFS", "Saigaon FFS", "Salebardi FFS", "Saloora FFS", "Satrapur (K.R.Bridge) FFS", "Tekra FFS", "Wairagarh FFS",
          "Saraswati Barrage","N.M. WEIR","Kunavaram_FFS","Polavaram Project","TALIPERU DAM","Bhatpalli FFS","Chikhali FFS","Chinnur FFS","G.R.BRIDGE FFS","Jannepally FFS",
          "Kalamadugu Bridge FFS","Kaleshwaram FFS","Katterasala FFS","","Kyathanpally Peddavagu FFS","Mancherial FFS","Nandigaon Peddavagu FFS","Pothangal FFS","Sirpur FFS","Somanpally FFS","Zari FFS","Chainage 5.2 km of Patiseema RMC","Koida FFS","Tallapudi_RR_FFS",
        ],

    "11": ["SIR AURTHUR COTTON BARRAGE","JAIKWADI","Lower Manair Dam","Lakshmi Barrage","Nizam Sagar Project","Sri Ram Sagar Project","Ashti FFS","Gudem (Pranhita River Bridge) FFS","P.G. Bridge FFS","Pauni FFS",
          "Kumhari FFS","Kaddam Adi Narayana Reddy Project","Mogaligundla Baga Reddy Singur Project","Sri Pada Yellampalli Project","Bamni  FFS","Venkatraopet (Wardha River) FFS","Konta FFS","Ramakona FFS","Yelli FFS",
          "SRR Reservoir", "Parvathi Barrage", "Upper Manair Dam", "Bhadrachalam FFS", "Bhandara FFS", "DEGLOOR FFS", "Dhalegaon FFS", "Gangakhed WL Station FFS", "Hivra FFS", "Indurthi Maneru FFS", "Kanhargaon FFS", "Keolari FFS", "Kopergaon FFS", "Mangrul FFS", "NANDED FFS", "Nandgaon FFS", "Nasik FFS", "Pachegaon FFS", "Pathagudem FFS", "Perur FFS",
          "Purna FFS", "Rajegaon FFS", "Rajoli FFS", "Saigaon FFS", "Salebardi FFS", "Saloora FFS", "Satrapur (K.R.Bridge) FFS", "Tekra FFS", "Wairagarh FFS",
          "Saraswati Barrage","N.M. WEIR","Kunavaram_FFS","Polavaram Project","TALIPERU DAM","Bhatpalli FFS","Chikhali FFS","Chinnur FFS","G.R.BRIDGE FFS","Jannepally FFS",
          "Kalamadugu Bridge FFS","Kaleshwaram FFS","Katterasala FFS","","Kyathanpally Peddavagu FFS","Mancherial FFS","Nandigaon Peddavagu FFS","Pothangal FFS","Sirpur FFS","Somanpally FFS","Zari FFS","Chainage 5.2 km of Patiseema RMC","Koida FFS","Tallapudi_RR_FFS",
          ],
    "12": ["SIR AURTHUR COTTON BARRAGE","JAIKWADI","Lower Manair Dam","Lakshmi Barrage","Nizam Sagar Project","Sri Ram Sagar Project","Ashti FFS","Gudem (Pranhita River Bridge) FFS","P.G. Bridge FFS","Pauni FFS",
           "Kumhari FFS","Kaddam Adi Narayana Reddy Project","Mogaligundla Baga Reddy Singur Project","Sri Pada Yellampalli Project","Bamni  FFS","Venkatraopet (Wardha River) FFS","Konta FFS","Ramakona FFS","Yelli FFS",
           "SRR Reservoir", "Parvathi Barrage", "Upper Manair Dam", "Bhadrachalam FFS", "Bhandara FFS", "DEGLOOR FFS", "Dhalegaon FFS", "Gangakhed WL Station FFS", "Hivra FFS", "Indurthi Maneru FFS", "Kanhargaon FFS", "Keolari FFS", "Kopergaon FFS", "Mangrul FFS", "NANDED FFS", "Nandgaon FFS", "Nasik FFS", "Pachegaon FFS", "Pathagudem FFS", "Perur FFS",
           "Purna FFS", "Rajegaon FFS", "Rajoli FFS", "Saigaon FFS", "Salebardi FFS", "Saloora FFS", "Satrapur (K.R.Bridge) FFS", "Tekra FFS", "Wairagarh FFS",
           "Saraswati Barrage","N.M. WEIR","Kunavaram_FFS","Polavaram Project","TALIPERU DAM","Bhatpalli FFS","Chikhali FFS","Chinnur FFS","G.R.BRIDGE FFS","Jannepally FFS",
           "Kalamadugu Bridge FFS","Kaleshwaram FFS","Katterasala FFS","","Kyathanpally Peddavagu FFS","Mancherial FFS","Nandigaon Peddavagu FFS","Pothangal FFS","Sirpur FFS","Somanpally FFS","Zari FFS","Chainage 5.2 km of Patiseema RMC","Koida FFS","Tallapudi_RR_FFS",
          ] ,
    "13": ["SIR AURTHUR COTTON BARRAGE","JAIKWADI","Lower Manair Dam","Lakshmi Barrage","Nizam Sagar Project","Sri Ram Sagar Project","Ashti FFS","Gudem (Pranhita River Bridge) FFS","P.G. Bridge FFS","Pauni FFS",
           "Kumhari FFS","Kaddam Adi Narayana Reddy Project","Mogaligundla Baga Reddy Singur Project","Sri Pada Yellampalli Project","Bamni  FFS","Venkatraopet (Wardha River) FFS","Konta FFS","Ramakona FFS","Yelli FFS",
           "SRR Reservoir", "Parvathi Barrage", "Upper Manair Dam", "Bhadrachalam FFS", "Bhandara FFS", "DEGLOOR FFS", "Dhalegaon FFS", "Gangakhed WL Station FFS", "Hivra FFS", "Indurthi Maneru FFS", "Kanhargaon FFS", "Keolari FFS", "Kopergaon FFS", "Mangrul FFS", "NANDED FFS", "Nandgaon FFS", "Nasik FFS", "Pachegaon FFS", "Pathagudem FFS", "Perur FFS",
           "Purna FFS", "Rajegaon FFS", "Rajoli FFS", "Saigaon FFS", "Salebardi FFS", "Saloora FFS", "Satrapur (K.R.Bridge) FFS", "Tekra FFS", "Wairagarh FFS",
            "Saraswati Barrage","N.M. WEIR","Kunavaram_FFS","Polavaram Project","TALIPERU DAM","Bhatpalli FFS","Chikhali FFS","Chinnur FFS","G.R.BRIDGE FFS","Jannepally FFS",
            "Kalamadugu Bridge FFS","Kaleshwaram FFS","Katterasala FFS","","Kyathanpally Peddavagu FFS","Mancherial FFS","Nandigaon Peddavagu FFS","Pothangal FFS","Sirpur FFS","Somanpally FFS","Zari FFS","Chainage 5.2 km of Patiseema RMC","Koida FFS","Tallapudi_RR_FFS",
          ] ,
     "14": ["SIR AURTHUR COTTON BARRAGE","JAIKWADI","Lower Manair Dam","Lakshmi Barrage","Nizam Sagar Project","Sri Ram Sagar Project","Ashti FFS","Gudem (Pranhita River Bridge) FFS","P.G. Bridge FFS","Pauni FFS",
            "Kumhari FFS","Kaddam Adi Narayana Reddy Project","Mogaligundla Baga Reddy Singur Project","Sri Pada Yellampalli Project","Bamni  FFS","Venkatraopet (Wardha River) FFS","Konta FFS","Ramakona FFS","Yelli FFS",
            "SRR Reservoir", "Parvathi Barrage", "Upper Manair Dam", "Bhadrachalam FFS", "Bhandara FFS", "DEGLOOR FFS", "Dhalegaon FFS", "Gangakhed WL Station FFS", "Hivra FFS", "Indurthi Maneru FFS", "Kanhargaon FFS", "Keolari FFS", "Kopergaon FFS", "Mangrul FFS", "NANDED FFS", "Nandgaon FFS", "Nasik FFS", "Pachegaon FFS", "Pathagudem FFS", "Perur FFS",
            "Purna FFS", "Rajegaon FFS", "Rajoli FFS", "Saigaon FFS", "Salebardi FFS", "Saloora FFS", "Satrapur (K.R.Bridge) FFS", "Tekra FFS", "Wairagarh FFS",
            "Saraswati Barrage","N.M. WEIR","Kunavaram_FFS","Polavaram Project","TALIPERU DAM","Bhatpalli FFS","Chikhali FFS","Chinnur FFS","G.R.BRIDGE FFS","Jannepally FFS",
            "Kalamadugu Bridge FFS","Kaleshwaram FFS","Katterasala FFS","","Kyathanpally Peddavagu FFS","Mancherial FFS","Nandigaon Peddavagu FFS","Pothangal FFS","Sirpur FFS","Somanpally FFS","Zari FFS","Chainage 5.2 km of Patiseema RMC","Koida FFS","Tallapudi_RR_FFS",
            ]



  },
  pointBelowLakshmiBarrage:[],//["Perur FFS","Bhadrachalam FFS","Koida FFS","Konta FFS","Chainage 5.2 km of Patiseema RMC","Polavaram Project","SIR AURTHUR COTTON BARRAGE"]
};
